import { ListingStatus, OfferListingStatus, PaymentTerms, PricingUnit, Product, RFQStatus } from '@steelbuy/ts-shared';
import { AddressIdentifier } from '@steelbuy/ui-primitive';
import { Steps } from '../app/components/create-listing/CreateListingContext.enums';
import { RFQStep } from '../app/components/create-rfq/CreateRFQ.enums';

export default {
    constants: {
        primaryAddress: {
            line1: 'Regus',
            line2: 'Central Boulevard',
            line3: 'Blythe Valley Business Park',
            line4: 'Solihull',
            line5: 'West Midlands',
            country: 'Inglaterra',
            postcode: 'B90 4BN',
        },
        customerServicePhone: '',
        companyRegistrationNumber: '',
        taxNumber: '',
        copyright: 'Copyright SteelBuy Ltd. 2022',
        companyName: 'SteelBuy Limited',
        companyNumber: '1914559',
        customerServiceTel: '44 (0) 121 713 7280',
        emailSupport: 'support@steel-buy.com',
        registerLink: 'https://steel-buy.com/account-registration/',
        emailInfo: 'info@steel-buy.com',
        tkCompanyName: 'thyssenkrupp Materials (UK) Ltd',
        trademarkNumber: 'UK00004153752',
        registrationNumber: 'UK00004156426',
        logoRegistrationNumber: 'UK00004153738',
        vatNumber: 'GB 695 9678 44',
        website: 'steel-buy.com',
        marketplace: 'steelbuy.app',
    },
    application: {
        acceptabelUsePolicy: {
            headerTitle: 'Política de Uso Aceptable',
        },
        account: {
            headerTitle: 'Cuenta',
            headerButtonAddNewUser: 'Agregar nuevo usuario',
            tabMyAccount: 'Mi cuenta',
            tabOrganisation: 'Empresa',
            tabUserManagement: 'Gestión de usuarios',
        },
        accountAddAddress: {
            errorMessage: 'Error al agregar la dirección. Por favor, inténtelo más tarde.',
            pageTitle: 'Agregar dirección de almacén',
            previousPageTitle: 'Cuenta de empresa',
        },
        accountEditAddress: {
            errorMessage: 'Error al editar la dirección. Por favor, inténtelo más tarde.',
            pageTitleInvoiceAddress: 'Editar dirección de facturación',
            pageTitleWarehouseAddress: 'Editar dirección de almacén',
            previousPageTitle: 'Cuenta de empresa',
        },
        accountEditAddressNotFound: {
            notFoundMessage: 'No se pudo encontrar esta dirección.',
            pageTitle: 'Editar dirección',
            previousPageTitle: 'Cuenta de empresa',
        },
        accountEditEmail: {
            pageTitle: 'Editar correo electrónico',
            previousPageTitle: 'Resumen de cuenta',
            successNotification:
                'Se ha enviado un correo a {{userEmail}} con instrucciones para verificar esta dirección.',
        },
        accountChangePassword: {
            pageTitle: 'Cambiar contraseña',
            incorrectPassword: 'La contraseña actual es incorrecta.',
            rateLimitError:
                'Lo sentimos, ha superado el número máximo de intentos para cambiar su contraseña. Por favor, inténtelo de nuevo en una hora.',
            genericErrorMessage: 'No podemos restablecer su contraseña en este momento; inténtelo más tarde.',
        },
        accountMFA: {
            pageTitle: 'Autenticación de dos factores',
            previousPageTitle: 'Resumen de cuenta',
            info: 'En lugar de esperar un mensaje de texto, obtenga códigos de verificación desde una aplicación de autenticación. Funciona incluso sin conexión. Primero, descargue la app Authenticator de Google Play o App Store.',
            inputLabel: 'Código de 6 dígitos',
            submit: 'Continuar',
            validationFailed: 'Validación fallida',
            codeMismatch: 'Código incorrecto',
            genericError: 'Ocurrió un error; por favor, inténtelo de nuevo más tarde.',
        },
        accountEditPaymentTerms: {
            formItemHeader: 'Términos de pago',
            inputLabel: '',
            pageTitle: 'Configuración de pagos',
            previousPageTitle: 'Cuenta de empresa',
            saveButtonLabel: 'Guardar cambios',
            saveErrorMessage: 'Error al guardar los cambios. Por favor, inténtelo más tarde.',
        },
        accountValidateEmail: {
            emailUpdated: 'Su dirección de correo ha sido actualizada.',
            unableToUpdateEmail: 'Actualmente no podemos actualizar su correo, por favor inténtelo más tarde.',
        },
        addressDetails: {
            additionalInformationLabel: 'Información adicional',
            collectionInformationLabel: 'Notas de la dirección de recogida',
            deliveryTimeframeLabel: 'Plazo de entrega',
            deliveryInformationLabel: 'Notas de la dirección de entrega (opcional)',
            addressNotLoadable: 'No se pudo cargar la dirección.',
            chooseAddressButtonLabel: 'Elegir otra dirección',
            deliveryInfoCollectionLabel: 'Dirección de recogida',
            sectionHeading: {
                [AddressIdentifier.BILLING_ADDRESS]: 'Dirección de facturación',
                [AddressIdentifier.DELIVERY_ADDRESS]: 'Dirección de entrega',
                [AddressIdentifier.PICKUP_ADDRESS]: 'Dirección de recogida',
                [AddressIdentifier.DELIVERY_INFO]: 'Información de entrega',
            },
        },
        addUser: {
            headerTitle: 'Agregar nuevo usuario',
            backLinkText: 'Gestión de usuarios',
            addUserButtonLabel: 'Crear usuario',
        },
        dashboard: {
            headerTitle: '¡Bienvenido, {{name}}!',
            searchListings: 'Buscar anuncios',
            bannerSearch: {
                header: 'Inicie su búsqueda',
                body: 'Busque materiales, configure una alerta y deje que encontremos el match que necesita.',
                buttonLabel: 'Buscar anuncios',
            },
            bannerSell: {
                header: 'Venda sus productos',
                body: 'Venda sus productos y obtenga un resumen del estado de sus ventas más recientes.',
                buttonLabel1: 'Crear anuncio',
                buttonLabel2: 'Mis anuncios',
            },
            urgentRequests: {
                headerTitle: 'Solicitud de material inmediato del comprador',
                helperText:
                    'Puede crear un nuevo anuncio basado en la solicitud de material inmediato del comprador. Una vez que su anuncio esté activo en el mercado, notificaremos al comprador por correo de los nuevos resultados que coincidan.',
                noUrgentRequests: 'Actualmente no hay solicitudes de material inmediato.',
                viewAll: 'Ver todas',
            },
            bannerRequest: {
                header: 'Solicitar material ahora',
                body: 'Llegue a toda nuestra red de vendedores y reciba respuesta en horas.',
                buttonLabel: 'Solicitar material',
            },
        },
        dashboardListings: {
            headerTitle: 'Panel',
            materialSelectionHeading: 'Explorar material',
            results: {
                header_zero: '{{count}} Resultados',
                header_one: '{{count}} Resultado',
                header_other: '{{count}} Resultados',
            },
            tableHeadings: {
                productName: 'Nombre del producto',
                gauge: 'Calibre',
                quality: 'Calidad',
                location: 'Ubicación',
            },
            sortByOption: 'Sortieren nach: {{option}}',
            filter: {
                buttonLabel: 'Filter',
                gaugeThickness: 'Calibre / Espesor',
            },
            viewDeliveredPrice: 'Ver precio entregado',
            deliveredTotal: 'Total entregado disponible en la página del producto',
            hrpoShort: 'HRPO',
        },
        dashboardRfq: {
            bannerNewAtSteelBuy: {
                header: 'Novedad en SteelBuy: Ofertas de fabricación',
                body: 'Envíe su RFQ de material directamente a varias plantas y compare cotizaciones antes de ordenar.',
                buttonLabel: 'Crear RFQ',
            },
        },
        addToCartConfirmModal: {
            headline: 'Añadido al carrito correctamente',
            continueShopping: 'Continuar comprando',
            viewCart: 'Ver carrito',
            checkoutBtn_one: 'Pagar ({{count}} artículo)',
            checkoutBtn_other: 'Pagar ({{count}} artículos)',
            addToCartFailed: 'El artículo puede haber expirado o haberse vendido y no puede añadirse al carrito.',
            alreadyInCart: 'Este anuncio ya está en el carrito.',
            actFast: '¡Actúe rápido! Su carrito se vaciará automáticamente en <time>{{time}}</time>',
            actFastSmallScreenModal: 'El carrito se vaciará automáticamente en <time>{{time}}</time>',
            itemsNotReserved: 'Los artículos no están reservados y pueden ser comprados por otros.',
            itemsNotReservedSmallScreenModal: 'Los artículos pueden ser comprados por otros.',
            insufficientCredit:
                'Saldo de crédito insuficiente para añadir este artículo al carrito. Por favor, añada fondos para continuar.',
        },
        cart: {
            entrySuccessMessage: 'Su anuncio ha sido eliminado del carrito.',
            entryErrorMessage: 'Error al eliminar el anuncio del carrito. Por favor, inténtelo de nuevo.',
            expiredMessage:
                'Su reserva ha expirado y los artículos en su carrito han sido eliminados. Por favor, inicie una nueva búsqueda para volver a añadirlos.',
            insufficientCreditMessage:
                'No puede completar la compra porque algunos artículos en su carrito no pueden comprarse por saldo de crédito insuficiente.',
        },
        cartReminderNotification: {
            message: 'El carrito se vaciará automáticamente en <time>{{time}} minutos.</time>',
            checkoutButtonLabel_one: 'Pagar ({{count}} artículo)',
            checkoutButtonLabel_other: 'Pagar ({{count}} artículos)',
        },
        checkout: {
            cancel: {
                content: 'Su pedido será eliminado.',
                confirmButtonLabel: 'Entendido',
            },
            header: {
                title: 'Pagar',
            },
            checkbox1Label:
                'Al marcar esta casilla, declaro que estoy autorizado para celebrar este contrato en nombre de {{organisationName}}.',
            checkbox2Label:
                'Al marcar esta casilla, acepto en nombre de {{organisationName}} que he leído y acepto los siguientes términos y condiciones: <websitetncs>Términos y Condiciones del Sitio</websitetncs>, <buyertncs>Términos y Condiciones para Compradores</buyertncs>.',
            negotiationExists: 'Otro miembro de su empresa está actualmente negociando este artículo.',
            creditLimitExceeded:
                'El precio de este producto supera su línea de crédito restante. ¿Necesita ayuda? Contacte a soporte: {{email}}',
            delivery: {
                title: 'Entrega',
                haulierRequiredMessage: '¿Necesitamos reservar una franja de entrega para este artículo?',
                checkboxYes: 'Sí',
                checkboxNo: 'No',
                materialLocationLabel: 'Ubicación del material',
            },
            purchaseOrderNumber: 'Su número de orden de compra',
            purchaseOrderPlaceholderText: 'PO3874387',
            purchaseOrderErrorMsg: 'Por favor, introduzca un número de orden de compra válido',
            deliveryText: 'Tiempo de entrega estimado',
            payment: {
                creditInfoNotification: 'El importe se deduce de su línea de crédito.',
                sectionHeading: 'Pago',
                optionCreditLabel: 'Crédito',
                optionCreditExplanation: 'Su pedido se enviará directamente.',
                optionUpfrontLabel: 'Pago por adelantado',
                optionUpfrontExplanation: 'Su pedido se enviará después de recibir su pago.',
            },
            priceUpdatedError:
                'El precio del anuncio ha sido actualizado, por favor revise el nuevo precio antes de comprar.',
            pricePerUnitInclDelivery: 'Precio por {{tradeUnit}} (incl. entrega)',
            shippingCostsLabel: 'Entrega',
            incompleteInformationNotification:
                'Por favor, complete toda la información requerida para completar la compra.',
            submitCheckoutButtonLabel: 'Confirmar y Pagar',
            totalPriceSectionHeading: 'Peso y Precio',
            totalExclVat: 'Total (sin IVA)',
            itemsTotalExclVat: 'Total de artículos (sin IVA)',
            itemsTotal: 'Total de artículos',
            totalInclVat: 'Total (con IVA)',
            vatLabel: '+ {{value}}% IVA',
            weight: 'Peso',
            theoreticalWeight: 'Peso teórico',
            offerDetails: 'Detalles de la oferta',
            error: {
                pageTitle: 'Lo sentimos. No pudimos realizar su pedido',
                retryMessage:
                    'Si el pedido no puede realizarse tras reintentar, por favor contacte a <link1>{{email}}</link1> para ayuda.',
                contactMessage:
                    'No se pudo realizar el pedido. Contacte a nuestro equipo de soporte <link1>{{email}}</link1> para ayuda.',
                contactSupport: 'Contactar Soporte',
                retry: 'Reintentar',
                link: 'Volver a la página de pago',
                unableToPurchaseCartWithRetry:
                    'Lo sentimos, no pudimos realizar su pedido. Si no se puede tras reintentar, contacte a <link1>{{email}}</link1> para ayuda.',
                unableToPurchaseCartAfterRetryExceeded:
                    'Lo sentimos, no pudimos realizar su pedido. Por favor contacte a <link1>{{email}}</link1> para ayuda.',
                creditLimitExceedContactSupport:
                    'Ha excedido su límite de crédito actual. Por favor contacte a <link1>{{email}}</link1> para ayuda.',
            },
        },
        checkoutAddAddress: {
            errorMessage: 'Error al añadir dirección. Por favor, inténtelo de nuevo más tarde.',
            pageTitle: 'Agregar nueva dirección',
            previousPageTitle: 'Elegir dirección',
        },
        checkoutChooseAddress: {
            pageTitle: 'Pagar',
        },
        checkoutDeliveryOption: {
            headerLabel: 'Opción de entrega',
            headerDescriptionLabel:
                '¿Debe SteelBuy entregar todos los artículos a una sola dirección o a varias direcciones?',
            singleAddressLabel: 'Dirección única',
            singleAddressDescriptionLabel: 'Su pedido se enviará a 1 dirección.',
            multipleAddressLabel: 'Múltiples direcciones',
            multipleAddressDescriptionLabel: 'Su pedido se enviará a múltiples direcciones.',
            orderSummary: 'Resumen del pedido',
            totalWeight: 'Peso total',
        },
        checkoutSuccess: {
            header: {
                title: 'Pagar',
            },
            successText: '¡SteelBuy ha recibido su solicitud de compra!',
            orderNumberText: 'Número de pedido SteelBuy:',
            purchaseOrderNumber: 'Su número de orden de compra:',
            steelbuyReferenceNumber: 'Número de referencia de SteelBuy:',
            emailHint: 'Recibirá un correo con confirmación, factura y certificado de fábrica.',
            deliveryHint: 'SteelBuy recogerá y entregará el material.',
            banner: {
                headline: '¿Tiene preguntas sobre su pedido?',
                contactText: 'No dude en contactarnos en:',
                emailLabel: 'Correo electrónico:',
            },
            searchListingsButtonLabel: 'Buscar anuncios',
            manageOrder: 'Gestione su pedido en <link1>Mis pedidos</link1>',
        },
        checkoutSuccessDynamicDelivery: {
            header: {
                title: 'Pedido confirmado',
            },
            successText1: 'Su transacción se ha realizado correctamente en SteelBuy.',
            successText2:
                'SteelBuy ha fijado el precio, ha verificado que el material está asegurado y ha iniciado los procesos de cumplimiento.',
            orderId: 'ID del pedido:',
            timestamp: 'Marca de tiempo:',
            whatsHappeningNow: 'Qué está pasando ahora',
            documentationIssued: 'Documentación digital emitida',
            documentationIssuedHint:
                'Recibirá una confirmación automática que incluye factura y certificados de prueba.',
            logisticsUnderway: 'Coordinación logística en marcha',
            logisticsUnderwayHint:
                'SteelBuy está coordinando la recogida, la transferencia de titularidad y la entrega según los términos acordados.',
            realTimeVisibility: 'Visibilidad en tiempo real',
            realTimeVisibilityHint:
                'Siga el estado del pedido, los documentos y las actualizaciones del envío en cualquier momento en Mis pedidos.',
            sourceMaterial: 'Buscar más material',
            viewOrderDetails: 'Ver detalles del pedido',
        },
        contactDetails: {
            header: {
                title: 'Contáctenos',
            },
        },
        createAlert: {
            title: 'Seleccione “solicitud de material inmediato” cuando necesite comprar material de inmediato y alertaremos a nuestros vendedores sobre su solicitud.',
            urgentRequest: 'Sí, solicitud inmediata de material',
            nonUrgentRequest: 'Ahora no, alerta normal',
        },
        createListingAddPickupAddress: {
            errorMessage: 'Error al añadir dirección. Por favor, inténtelo de nuevo más tarde.',
            pageTitle: 'Agregar dirección de almacén',
            previousPageTitle: 'Elegir dirección de recogida',
        },
        createListingOverview: {
            notificationSuccess: 'Su borrador ha sido eliminado con éxito.',
            notificationError: 'No se pudo eliminar su borrador.',
        },
        createListingListUpload: {
            packageTitleHeader: 'Título del paquete',
            packageTitleLabel: 'Título del paquete para compradores',
            packageTitlePlaceholder: 'p.ej., 20 bobinas galvanizadas, laminado en caliente...',
            packageDescriptionLabel: 'Descripción del paquete para compradores',
            packageDescriptionHeader: 'Descripción del paquete',
            packageDescriptionPlaceholder:
                'Por favor describa su paquete para que los compradores entiendan fácilmente el contenido.',
            packageListUploadHeader: 'Carga de lista de paquete (archivo Excel)',
            packageListUploadLabel: 'Suba un archivo Excel con todos los artículos del paquete',
            packageFileInputHelperText: 'Archivo Excel ({{fileType}})',
        },
        createListingChoosePickupAddress: {
            pageTitle: 'Elegir dirección de recogida',
            previousPageTitle: 'Crear anuncio',
        },
        createListing: {
            draftSuccessfulNotification: 'Su borrador se ha guardado con éxito.',
            draftFailedNotification: 'Error al guardar el anuncio como borrador.',
            packageDraftFailedNotification: 'Error al guardar el paquete como borrador.',
            headerCreateNew: 'Crear anuncio',
            headerEditDraft: 'Editar anuncio borrador',
            rejectedListingConvertedToDraft:
                'El anuncio rechazado se ha convertido en borrador. Ahora aparece en “Mis anuncios”.',
            targetPriceHeader: 'Precio objetivo',
        },
        createListingPortal: {
            header: 'Crear Anuncio',
            single: {
                heading: 'Crear un Anuncio Individual',
                description: 'Ideal si estás anunciando un solo artículo o si recién estás comenzando.',
                button: 'Crear un anuncio',
            },
            bulk: {
                heading: 'Carga Masiva de Anuncios',
                description: 'Recomendado si tienes varios anuncios listos en una hoja de cálculo.',
                button: 'Subir hoja de cálculo',
            },
        },
        createBulkListing: {
            header: 'Carga masiva de anuncios',
            goBack: 'Crear anuncio',
            chooseMaterial: {
                header: 'Elige tu material deseado',
            },
            importListing: {
                header: 'Importar anuncios desde XLS',
                label: 'Subir hoja de cálculo con anuncios',
                fileInputHelperText: '.xls, .xlsx',
                uploadError: 'Error al leer el archivo.',
            },
            labels: {
                CHOOSE_MATERIAL: 'Elegir material',
                IMPORT_LISTINGS: 'Importar anuncios',
                EDIT_LISTINGS: 'Editar anuncios',
                EXPIRY_DATE: 'Fecha de caducidad',
            },
            editListings: {
                header: 'Editar anuncios ({{count}})',
                successMessage: `Carga completa. Hemos extraído sus listados y ahora están listos para revisar. Es posible que algunos campos aún necesiten su entrada; verifique los detalles a continuación antes de enviarlos.`,
                summaryMessage: '{{uploadedCount}} anuncios subidos. {{incompleteCount}} esperando tu revisión.',
                completeness: 'Lo completo',
                completed: 'Terminado ({{filled}}/{{total}})',
                sellingPrice: 'Precio de venta por {{pricingUnit}}',
                listingDeleted: 'El listado se ha eliminado correctamente.',
                collectionAddress: 'Dirección de recogida',
                notApplicable: 'N/A',
                unsavedChanges:
                    'Estos listados tienen cambios no guardados. ¿Quieres guardarlo como borrador antes de regresar?',
            },
            expiryDate: {
                header: 'Fecha de caducidad',
            },
            fields: {
                weight: 'Peso ({{tradeUnit}})',
                theoreticalWeight: 'Peso teórico ({{tradeUnit}})',
                sellingPrice: 'precio de venta',
                price: 'Precio (por tonelada)',
                testCertificate: 'Certificado de prueba',
                picture: 'Foto',
                collectionAddress: 'Dirección de recogida',
                expiryDate: 'Fecha de vencimiento',
                autoRenewal: 'Renovación automática',
                yes: 'Sí',
                no: 'No',
                priceValue: '{{price}}/{{pricingUnit}}',
                testCertToFollow: 'Próximamente',
                description: 'Descripción detallada',
                width: 'Ancho ({{- unit}})',
                thickness: 'Espesor ({{- unit}})',
                length: 'Longitud ({{- unit}})',
            },
            editListingModal: {
                header: 'Editar listado ({{index}}/{{total}})',
                incompleteNotification: 'Por favor ingrese todos los campos que faltan.',
                uploadTestCertificate: 'Cargar certificado de prueba',
                previouslyUploadedLabel: 'Seleccione un archivo cargado previamente',
                uploadNewFile: 'Subir nuevo archivo',
                uploadNewFileNow: 'Subir un archivo nuevo ahora',
                testCertToFollow: 'Certificado de prueba a seguir',
                inputWeightLabel: 'peso ({{tradeUnit}})',
                theoreticalWeight: 'Peso teórico ({{tradeUnit}})',
                files: 'Archivos',
                successNotification: 'Listado ha sido actualizado',
                saveAndNext: 'Guardar y siguiente',
                saveAndNextTooltip: 'Guardar cambios y pasar al siguiente anuncio',
                saveTooltip: 'Guardar cambios y cerrar ventana emergente',
                materialIdLabel: 'ID de material',
                deleteListingLabel: 'Eliminar anuncio',
                saveAndNextHelper: 'Guardar y siguiente = Guardar y pasar al siguiente',
                selectTestCertNotification: 'Seleccione 1 archivo.',
            },
            summary: {
                submitListings: 'Enviar anuncios',
                listings: 'Anuncios',
                totalListings: 'Total de anuncios',
                totalDocuments: 'Total de documentos',
                totalImages: 'Total images',
                failedSubmissionMessage: 'No se pudieron enviar listados. Inténtelo de nuevo más tarde.',
            },
            deleteModal: {
                textContent: '¿Estás seguro de que quieres eliminar este anuncio?',
            },
        },
        createBulkListingSuccess: {
            buttonLabelCreateNew: 'Crear anuncio',
            marketingBannerHeader: '¿Tienes alguna pregunta sobre tus anuncios?',
            nextStepReview:
                'Nuestro equipo revisará los anuncios para garantizar que cumplan con los estándares de calidad.',
            notificationMessage: 'Tus anuncios están en revisión.',
        },
        createListingDraftNotFound: {
            pageTitle: 'Borrador de anuncio no encontrado',
            previousPageTitle: 'Resumen',
            notificationMessage:
                'No se encontró este borrador de anuncio. Puede haber sido eliminado o publicado para revisión.',
            notificationButtonLabel: 'Crear nuevo anuncio',
        },
        createListingSaveDraftButton: {
            label: 'Guardar como borrador',
        },
        createListingSteps: {
            labels: {
                [Steps.MATERIAL]: 'Materiales',
                [Steps.DIMENSIONS]: 'Dimensiones',
                [Steps.WEIGHT_PRICE]: 'Peso y Precio',
                [Steps.PICKUP_ADDRESS]: 'Dirección de recogida',
                [Steps.LIST_UPLOAD]: 'Carga de lista',
                [Steps.DELIVERY_INFO]: 'Información de entrega',
            },
        },
        createListingButtons: {
            viewSummaryButtonLabel: 'Ver resumen',
            wizardNextButtonLabel: 'Siguiente',
        },
        createListingSuccess: {
            buttonLabelCreateNew: 'Crear nuevo anuncio',
            buttonLabelCreateSame: 'Crear anuncio similar',
            buttonLabelMyListings: 'Mis anuncios',
            header: 'Crear anuncio',
            marketingBannerHeader: '¿Tiene preguntas sobre su pedido?',
            marketingBannerText: 'No dude en contactarnos en:',
            nextStepsHint: 'Siguientes pasos',
            nextStepNotification: 'Recibirá una notificación cuando esté activo.',
            nextStepReview: 'Nuestro equipo revisará el anuncio para asegurar que cumpla los estándares de calidad.',
            notificationMessage: 'Su anuncio está en revisión.',
        },
        createListingSummary: {
            errorNotificationMessage: 'Ocurrió un error, por favor intente de nuevo más tarde.',
            header: 'Resumen',
            submitButtonLabel: 'Enviar anuncio',
            weightAndPriceHeader: 'Peso y su precio de venta',
            weightAndPriceNotification: 'Añadiremos una tarifa de envío y servicio a su precio.',
            weightAndPriceNotificationTheoretical:
                'Añadiremos una tarifa de envío y servicio a su precio. Venderá este artículo basado solo en peso teórico.',
            checkboxLabel:
                'Al marcar esta casilla, acepto en nombre de {{organisationName}} que he leído y acepto los siguientes términos y condiciones: <websitetncs>Términos y Condiciones del Sitio</websitetncs>, <sellertncs>Términos y Condiciones para Vendedores</sellertncs>',
            websiteTCLinkText: 'Términos y Condiciones del Sitio',
            sellerTCLinkText: 'Términos y Condiciones para Vendedores',
        },
        createListingUnsavedChangesModal: {
            discardButtonLabel: 'Descartar cambios',
            headline: 'Este anuncio tiene cambios sin guardar.',
            savingFailedNotification: 'Error al guardar, por favor intente de nuevo más tarde.',
        },
        createRFQUnsavedChangesModal: {
            headline: 'Esta RFQ tiene cambios sin guardar.',
        },
        createRFQ: {
            headerCreateNew: 'Crear RFQ',
            headerEditDraft: 'Editar borrador de RFQ',
            submitButtonLabel: 'Enviar RFQ',
            chooseMaterial: 'Elija el material deseado',
            addItems: 'Añada artículos a su Solicitud de Cotización (RFQ)',
            chooseMaterialOrigin: 'Elija origen preferido y mes de entrega requerido',
            wizardNextButtonLabel: 'Siguiente',
            viewSummary: 'Ver resumen',
            comments: 'Comentarios',
            selectPlaceholder: 'Elija una opción',
            addSimilar: 'Añadir similar',
            actions: 'Acciones',
            addToRFQ: 'Añadir a RFQ',
            saveAsDraft: 'Guardar como borrador',
            deleteRFQItemConfirmation: '¿Está seguro de que desea eliminar este artículo?',
            unsavedItemModal: {
                headline: 'Tiene cambios sin guardar en el artículo',
                continueLabel: 'Continuar sin guardar',
            },
            materialOrigin: {
                header: 'Origen(es) de material preferido(s)',
                description:
                    'Por favor seleccione uno o varios orígenes. (Europa Occidental: UE, Reino Unido, Suiza, Noruega)',
            },
            preferredOrigin: 'Origen(es) preferido(s)',
            deliveryMonth: {
                header: 'Mes de entrega requerido',
                description: 'Seleccione su mes de entrega requerido del menú.',
                subHeader: 'Mes de entrega requerido',
            },
            fieldRequired: 'Este campo es obligatorio.',
            quoteDeadline: {
                header: 'Fecha límite de cotización',
                subHeader: 'Fecha límite de cotización',
                description:
                    'Por favor especifique la fecha límite para recibir cotizaciones. La cotización expirará al finalizar la fecha seleccionada.',
            },
            additionalComments: {
                header: 'Comentarios adicionales',
                description:
                    'Por favor proporcione comentarios adicionales sobre la calidad deseada del material para la RFQ.',
            },
            rfqDetails: 'Detalles de RFQ',
            downloadRfq: 'Descargar RFQ',
            rfqReferenceNumber: 'Número de referencia de RFQ',
        },
        myRFQ: {
            header: 'Mis RFQs',
            submitted: 'Enviadas',
            drafts: 'Borradores',
            noResultsDescription: 'Crear nueva RFQ del material que desea comprar.',
            noListingsCallToAction: 'Crear RFQ',
            numberOfRFQListings_zero: 'No hay RFQs',
            numberOfRFQListings_one: '{{count}} RFQ',
            numberOfRFQListings_other: '{{count}} RFQs',
            notificationMsg:
                'Los vendedores pueden revisar la lista de productos y responder con cotización. Usted puede aceptar o rechazar la cotización.',
            publishRfq: 'PUBLICAR RFQ',
            createSimilarRFQ: 'Crear RFQ similar',
            statusText: {
                header: {
                    [RFQStatus.UNDER_REVIEW]: 'Enviado para revisión el:',
                    [RFQStatus.REJECTED]: 'Rechazado el:',
                    [RFQStatus.LIVE]: 'Publicado el:',
                    [RFQStatus.WITHDRAWN]: 'Retirado el:',
                    [RFQStatus.EXPIRED]: 'Caducado el:',
                },
            },
            emailSubject: 'Rechazo de RFQ {{quoteRef}}',
            searchPlaceHolder: 'Número de referencia RFQ',
            clearSearch: 'Borrar búsqueda',
        },
        myRFQDetails: {
            withdrawRfq: 'Retirar RFQ',
            withdrawSuccess: 'Su RFQ ha sido retirada.',
            withdrawFailure: 'No se pudo retirar su RFQ. Por favor, intente más tarde.',
            withdrawModal: {
                header: '¿Está seguro de que desea retirar su RFQ?',
                confirmLabel: 'Retirar RFQ',
            },
            updateFailure: 'No se pudo publicar su RFQ. Por favor, intente más tarde.',
            success: 'Su RFQ está activa.',
            notificationMsg:
                'Puede renovar esta RFQ estableciendo una nueva fecha límite, lo que le permitirá publicarla directamente a los vendedores. También puede ajustar los detalles de su RFQ si es necesario, haciendo clic en Crear RFQ Similar.',
            restartRFQSuccess: 'La RFQ rechazada se ha convertido en borrador. Ahora aparece en “Mis RFQs”.',
            restartRFQFailure: 'Error al convertir a borrador de RFQ. Por favor, intente más tarde.',
        },
        myRFQDraft: {
            numberOfRFQDraftListings_zero: 'Sin borradores',
            numberOfRFQDraftListings_one: '{{count}} Borrador',
            numberOfRFQDraftListings_other: '{{count}} Borradores',
        },
        myQuotes: {
            tableHeadings: {
                materialSpecs: 'Especificaciones de materiales',
                totalWeight: 'peso total',
                rfqStatus: 'RFQ estado',
                createdAt: 'Creado el',
                rfqReferenceNo: 'RFQ número de referencia',
            },
            rfqStatus: {
                [RFQStatus.UNDER_REVIEW]: 'Abierto',
                [RFQStatus.CLOSED]: 'Cerrado',
            },
            statusText: {
                header: {
                    [RFQStatus.UNDER_REVIEW]: 'Abierto en:',
                    [RFQStatus.CLOSED]: 'Cerrado a las:',
                },
            },
            extraListingsCount: '+{{count}} más',
            matchListings: {
                header: 'Listados coincidentes del mercado',
                subHeader: 'Coincidencias instantáneas encontradas en listados de mercados existentes.',
            },
        },
        myRFQFilter: {
            selectLabel: 'Filtrar por',
            selectPlaceholder: 'Elija opciones',
            optionLabels: {
                [RFQStatus.REJECTED]: 'Rechazado',
                [RFQStatus.LIVE]: 'Activo',
                [RFQStatus.WITHDRAWN]: 'Retirado',
                [RFQStatus.EXPIRED]: 'Caducado',
                [RFQStatus.UNDER_REVIEW]: 'En revisión',
            },
        },
        myCart: {
            header: 'Carrito de compras',
            infoMsg: 'Los artículos no están reservados y pueden ser comprados por otros.',
            noItemCallToAction: 'Buscar anuncios',
            noItemCaption: 'El carrito está vacío',
            noResultsDescription: 'Busque y compre anuncios ahora.',
            itemsExpiredOrSold:
                'Algunos artículos pueden haber expirado o sido vendidos. Su carrito ha sido actualizado.',
            itemsRenewed: '<property>{{property}}:</property> de {{oldPrice}} a {{newPrice}} {{pricingUnit}}',
            itemsRenewedMessage: '{{count}} de los artículos en su carrito tienen un nuevo precio del vendedor.',
        },
        createRFQSteps: {
            labels: {
                [RFQStep.CHOOSE_MATERIALS]: 'Elija materiales',
                [RFQStep.ADD_ITEMS]: 'Añadir artículos',
                [RFQStep.SHIPPING_DETAILS]: 'Detalles de envío',
                [RFQStep.COMMENTS]: 'Comentarios',
            },
        },
        createRFQSuccess: {
            buttonLabelCreateNew: 'Crear RFQ',
            buttonLabelMyListings: 'Mis RFQs',
            header: 'Crear RFQ',
            marketingBannerHeader: '¿Tiene preguntas sobre su RFQ?',
            marketingBannerText: 'No dude en contactarnos en:',
            nextStepsHint: 'Siguientes pasos',
            nextStepNotification: 'Recibirá notificación cuando esté activa.',
            nextStepReview: 'Nuestro equipo revisará la RFQ para asegurar que cumpla estándares de calidad.',
            notificationMessage: 'Su RFQ está en revisión.',
            referenceNumber: 'Número de referencia de RFQ:',
            matchesHeader: 'Coincidencias instantáneas de productos',
            matchesDescription1: 'Se encontraron coincidencias instantáneas de anuncios existentes en el mercado.',
            matchesDescription2: 'Puede revisarlas en la página de detalles de la RFQ.',
            noMatches: 'Aún no hay coincidencias disponibles',
            instantProductMatchesFrom: 'Coincidencias instantáneas de productos de...',
            myRfqsLink: 'Cualquier coincidencia aparecerá en la RFQ en <link1>Mis RFQs</link1>',
        },
        createRFQSummary: {
            submitButtonLabel: 'Enviar RFQ',
            header: 'Resumen',
            createRFQFailed: 'Ocurrió un error, por favor intente más tarde.',
        },
        createDraftRFQ: {
            createDraftRFQFailed: 'Ocurrió un error, por favor intente más tarde.',
            createDraftRFQSuccess: 'Su borrador se ha guardado con éxito.',
        },
        addRfq: {
            addTitle: 'Agregar nuevo artículo',
            addDescription:
                'Para añadir un artículo, complete todos los campos en la fila. Una vez llenos, haga clic en “Añadir a RFQ”.',
            itemExists: 'El artículo ya existe. Por favor, modifique.',
            genericError: 'Valores de formulario inválidos.',
        },
        legalCheckboxes: {
            checkbox1Label:
                'Al marcar esta casilla, declaro que estoy autorizado para celebrar este contrato en nombre de {{organisationName}}.',
            checkbox2Label:
                'Al marcar esta casilla, acepto en nombre de {{organisationName}} que he leído y acepto los siguientes términos y condiciones: <websitetncs>Términos y Condiciones del Sitio</websitetncs>, <buyertncs>Términos y Condiciones para Compradores</buyertncs>.',
        },
        editUser: {
            headerTitle: 'Editar usuario',
            backLinkText: 'Gestión de usuarios',
            saveUserButtonLabel: 'Guardar cambios',
            toggleUserSuccess: {
                enabled: 'El usuario ha sido reactivado con éxito',
                disabled: 'El usuario ha sido desactivado con éxito',
            },
            toggleUserError: {
                enabled: 'Error al desactivar al usuario. Por favor, intente más tarde.',
                disabled: 'Error al reactivar al usuario. Por favor, intente más tarde.',
            },
        },
        footer: {
            termsLinkText: 'Términos y Condiciones',
            contactDetailsLinkText: 'Contáctenos',
            privacyPolicyLinkText: 'Política de Privacidad',
            acceptableUseLinkText: 'Política de Uso Aceptable',
            claimsPolicyText: 'Política de reclamaciones',
        },
        genericError: {
            dashboardButtonLabel: 'Ir al Panel',
            helperText: '¡Ups! Algo salió mal. Por favor vuelva o recargue esta página.',
            reloadButtonLabel: 'Recargar',
        },
        legal: {
            headerTitle: 'Notas legales',
        },
        listingDetails: {
            detailedDescription: 'Descripción detallada',
            testCertificateTitle: 'Certificado de fábrica',
            deliveryTitle: 'Entrega',
            deliveryText: 'Tiempo de entrega estimado',
            checkoutButtonText: 'Comprar ahora',
            offerButtonText: 'Hacer una oferta',
            packageListSheetTitle: 'Hoja de cálculo de lista de paquetes',
            fetchingPriceMessage:
                'Espere mientras obtenemos la información de precios más reciente; vuelva a intentarlo una vez que se actualice el precio.',
        },
        listingNotFound: {
            notFoundMessage: 'Lo sentimos, este producto ya no está disponible.',
            newSearchMessage: 'Quizá un producto similar ya le esté esperando.',
            newSearchButton: 'Iniciar nueva búsqueda',
        },
        listingSearchForm: {
            headerTitle: 'Buscar anuncios',
            theoreticalWeightNotification: 'Peso teórico máximo posible.',
        },
        ListingSearchFormInputs: {
            refineSearch: 'Refine su búsqueda',
            incompleteInformationNotification:
                'Por favor complete toda la información requerida para enviar su solicitud de material.',
            submitText: 'Buscar',
            weightLabel: 'Peso requerido',
            theoreticalWeightLabel: 'Solo será notificado de material basado en peso teórico.',
            targetPriceHeader: 'Precio objetivo deseado',
            targetPriceDescription:
                'Tenga en cuenta que ofertas muy por debajo del valor de mercado pueden ser ignoradas por vendedores.',
            targetPriceLabel: 'Precio objetivo deseado (opcional)',
            minimumTargetPriceError: 'Por favor introduzca un monto más alto para que coincida con el valor de mercado',
            numberOfItems: {
                [Product.SHEET]: 'Número de láminas requerido',
                [Product.PLATE]: 'Número de placas requerido',
                [Product.TREAD]: 'Número de placas antideslizantes requerido',
                [Product.FLOOR]: 'Número requerido de placas de piso',
            },
        },
        listingAlertNotification: {
            explanation: 'Cree una alerta y le notificaremos por correo sobre nuevos resultados que coincidan.',
            createSuccess: 'Ha creado una alerta.',
            deleteSuccess: 'Su alerta ha sido eliminada.',
            link: 'Puede encontrar sus alertas en Mis Alertas.',
        },
        listingSearchResults: {
            addAlertButtonLabel: 'Crear alerta',
            deleteAlertButtonLabel: 'Eliminar alerta',
            header: {
                title: 'Resultados de búsqueda',
                backLinkText: 'Criterios de búsqueda',
            },
            editSearchButtonTitle: 'Editar búsqueda',
            noResultsText: 'Actualmente no hay resultados para su búsqueda.',
            noResultsButtonLabel: 'Editar criterios de búsqueda',
        },
        locationAwareGenericError: {
            pageTitle: 'Algo salió mal',
        },
        materialStep: {
            anonymityBannerHeader: '¡La anonimidad es importante para nosotros!',
            anonymityBannerText: 'Su certificado será anonimizado por SteelBuy.',
            missingProductsNotification: '¿No encuentra el producto que busca?',
            missingProductsLinkLabel: '¡Notifíquenos!',
            missingProductsEmailSubject: 'Producto faltante',
        },
        myAccount: {
            myAccountCardHeader: 'Mi cuenta',
            myAccountCardEmailLabel: 'Correo electrónico',
            myAccountCardNameLabel: 'Nombre',
            editEmailAddress: 'Editar correo electrónico',
            passwordCardButtonLabel: 'Actualizar contraseña',
            passwordCardHeader: 'Contraseña',
            permissionCardHeader: 'Mis permisos',
            mfa: {
                header: 'Autenticación de dos factores',
                button: 'Cambiar configuración',
                enabled: 'Activado',
                disabled: 'Desactivado',
            },
        },
        myAlertsOverview: {
            deleteSuccess: 'Su alerta ha sido eliminada.',
            pageHeader: 'Mis alertas',
            pageHeaderButton: 'Iniciar nueva búsqueda',
        },
        myOffers: {
            pageHeader: 'Mis ofertas',
            dataHeader: {
                numberOfOffers_zero: 'Sin ofertas',
                numberOfOffers_one: '{{count}} Oferta',
                numberOfOffers_other: '{{count}} Ofertas',
            },
            noResultsText: 'Actualmente no hay ofertas.',
            infoMsg:
                'El vendedor puede revisar el precio propuesto y decidir aceptarlo, rechazarlo o presentar una contraoferta. Si no se toma ninguna acción antes de la fecha y hora indicadas, la negociación se cancelará automáticamente.',
        },
        myAlertsSearchResults: {
            pageHeader: 'Resultados',
            previousPageTitle: 'Mis alertas',
            notificationIllustratedHeader: '¡Es una coincidencia!',
            notificationIlulustratedHelperText: 'Revise los nuevos anuncios que coinciden con su búsqueda',
            searchSummaryNewResults: '{{numListings}} nuevos',
        },
        myAlertsSettings: {
            changesSavedNotificationMessage: '¡Sus cambios han sido guardados!',
            deleteButtonLabel: 'Eliminar alerta',
            header: 'Configuración de alertas',
            headerBackLinkLabel: 'Mis alertas',
            mailNotificationHeader: 'Notificaciones por correo',
            mailNotificationLabel: 'Recibirá un correo a {{email}} tan pronto como un producto coincida con su alerta.',
            receiveNotifications: 'Recibir notificaciones',
            saveButtonLabel: 'Guardar cambios',
            errorHeading: 'Se requiere rol de vendedor para acceder',
            errorMessage:
                'Esta configuración solo está disponible para usuarios con rol de Vendedor. Contacte a un administrador si necesita acceso.',
        },
        myListings: {
            header: 'Mis anuncios',
            noResultsDescription: 'Crear nuevo anuncio para el material que desea vender.',
            noListingsCallToAction: 'Crear anuncio',
            numberOfListings_zero: 'Sin anuncios',
            numberOfListings_one: '{{count}} Anuncio',
            numberOfListings_other: '{{count}} Anuncios',
            numberOfDrafts_zero: 'Sin borradores',
            numberOfDrafts_one: '{{count}} Borrador',
            numberOfDrafts_other: '{{count}} Borradores',
            listings: 'Anuncios',
            drafts: 'Borradores',
            subTabListingLabel: 'Anuncios principales',
            subTabDraftsLabel: 'Borradores principales',
            bulkFilterNotification:
                'Actualmente estás viendo un conjunto de listados filtrados por ID de carga masiva. Para ver todos los listados,',
            bulkRemoveFilter: 'elimine el filtro.',
        },
        myPackages: {
            numberOfPackageListings_zero: 'Sin anuncios de paquete',
            numberOfPackageListings_one: '{{count}} Anuncio de paquete',
            numberOfPackageListings_other: '{{count}} Anuncios de paquete',
            numberOfPackageDrafts_zero: 'Sin borradores',
            numberOfPackageDrafts_one: '{{count}} Borrador de paquete',
            numberOfPackageDrafts_other: '{{count}} Borradores de paquete',
            subTabPackageLabel: 'Anuncios de paquete',
            subTabDraftsLabel: 'Borradores de paquete',
        },
        myBulkDrafts: {
            subTabDraftsLabel: 'Borradores cargados en masa',
            deleteModal: {
                header: '¿Está seguro de que desea eliminar todos los {{count}} listados en este borrador? Esta acción no se puede deshacer.',
                deleteCta: '¡Sí, borrar todo!',
            },
        },
        myListingsFilter: {
            selectLabel: 'Filtrar por',
            selectPlaceholder: 'Elija opciones',
            optionLabels: {
                [ListingStatus.DRAFT]: 'Borrador',
                [ListingStatus.REVIEW_REQUIRED]: 'En revisión',
                [ListingStatus.REVIEW_REJECTED]: 'Rechazado',
                [ListingStatus.PUBLISHED]: 'Activo',
                [ListingStatus.PURCHASED]: 'Vendido',
                [ListingStatus.WITHDRAWN]: 'Retirado',
                [ListingStatus.EXPIRED]: 'Caducado',
            },
        },
        manageOffers: {
            pageHeader: 'Gestionar ofertas',
            dataHeader: {
                numberOfOffers_zero: 'Sin ofertas',
                numberOfOffers_one: '{{count}} Oferta',
                numberOfOffers_other: '{{count}} Ofertas',
            },
            noResultsText: 'Actualmente no hay ofertas.',
            infoMsg:
                'El comprador puede revisar el precio propuesto y decidir aceptarlo, rechazarlo o presentar una contraoferta. Si no se toma ninguna acción antes de la fecha y hora indicadas, la negociación se cancelará automáticamente.',
        },
        offerListingsFilter: {
            selectLabel: 'Filtrar por',
            selectPlaceholder: 'Elija opciones',
            awaitingYourResponse: 'Esperando su respuesta',
            optionLabels: {
                [OfferListingStatus.AWAITING_BUYER]: 'Esperando la respuesta del comprador',
                [OfferListingStatus.AWAITING_SELLER]: 'Esperando la respuesta del vendedor',
                [OfferListingStatus.ACCEPTED]: 'Aceptado',
                [OfferListingStatus.REJECTED]: 'Rechazado',
                [OfferListingStatus.WITHDRAWN]: 'Retirado',
                [OfferListingStatus.EXPIRED]: 'Caducado',
                [OfferListingStatus.CANCELLED]: 'Cancelado',
                [OfferListingStatus.PURCHASED]: 'Vendido',
            },
        },
        offers: {
            negotiationsHeader: 'Está negociando en este anuncio',
            accordionHeader: 'Número de referencia de negociación: {{referenceId}}',
            timeLeft: 'Tiempo restante para actuar',
            tableHeadings: {
                offersAndCounterOffers: 'Ofertas y contraofertas',
                date: 'Fecha',
                requestBy: 'Solicitado por',
                action: 'Acción',
            },
            reject: 'Rechazar',
            counter: 'Contraofertar',
            accept: 'Aceptar',
            withdraw: 'Retirar oferta',
            hours: 'horas',
            minutes: 'minutos',
            acceptModelHeader: '¿Está seguro de que desea aceptar esta oferta?',
            buyNowModalheader:
                'Existe una oferta en curso. ¿Está seguro de que desea continuar con la compra al precio original?',
            addToCartModalHeader:
                'Existe una oferta en curso. ¿Está seguro de que desea añadir el anuncio al carrito al precio original?',
            buynow: 'Comprar ahora',
            submitCounterOffer: 'Enviar contraoferta',
            review: 'Revisar',
            priceExceed: 'El monto ingresado es superior al precio original.',
            minimumPriceError: 'Por favor ingrese un monto más alto para ajustarse al valor de mercado.',
            limitPriceExceed: 'El monto ingresado supera su límite de crédito.',
            buyerCounterInfoMsg: 'Enviaremos una respuesta del comprador en {{timeLeft}}',
            sellerCounterInfoMsg: 'Enviaremos una respuesta del vendedor en {{timeLeft}}',
            counterOffer: 'Su contraoferta',
            reviewCounterOffer: 'Revisar contraoferta',
            pricelabel: 'Precio original por {{pricingUnit}}',
            buyerOfferedPriceLabel: 'Oferta del comprador por {{pricingUnit}}',
            sellerOfferedPriceLabel: 'Oferta del vendedor por {{pricingUnit}}',
            proposedPrice: 'Su precio propuesto por {{pricingUnit}}',
            total: 'Total',
            reviewPricingUnit: {
                [PricingUnit.TON]: {
                    label: 'Peso',
                },
                [PricingUnit.KILOGRAM]: {
                    label: 'Peso',
                },
                [PricingUnit.SHEET]: {
                    label: 'Artículos',
                },
                [PricingUnit.PLATE]: {
                    label: 'Artículos',
                },
                [PricingUnit.TREAD]: {
                    label: 'Artículos',
                },
                [PricingUnit.CWT]: {
                    label: 'Peso',
                },
                [PricingUnit.LB]: {
                    label: 'Peso',
                },
            },
            rejectModelHeader: '¿Está seguro de que desea rechazar esta oferta?',
            withdrawModalHeader: '¿Está seguro de que desea retirar su oferta?',
            counterMsgSeller: 'Su contraoferta ha sido recibida. Recibirá una respuesta del comprador pronto.',
            counterMsgBuyer: 'Su oferta ha sido recibida. Recibirá una respuesta del vendedor pronto.',
            counterErrorMSg: 'Actualmente no se puede realizar una contraoferta, por favor intente de nuevo.',
            acceptErrorMsg: 'Actualmente no se puede aceptar la oferta, por favor intente de nuevo.',
            rejectErrorMsg: 'Actualmente no se puede rechazar la oferta, por favor intente de nuevo.',
            withdrawErrorMsg: 'Actualmente no se puede retirar la oferta, por favor intente de nuevo.',
            acceptMsgBuyer:
                'Ha aceptado la oferta del vendedor. Complete su compra en las próximas 24 horas para asegurar su artículo.',
            rejectMsgBuyer: 'Su rechazo de oferta está confirmado.',
            withdrawMsg: 'Su oferta ha sido retirada.',
            acceptMsgSeller:
                'El vendedor ha aceptado la oferta, estará disponible hasta que termine el periodo de solicitud.',
            rejectMsgSeller: 'El vendedor ha rechazado la oferta.',
            notificationMsgBuyer:
                'El vendedor puede revisar el precio propuesto y decidir aceptarlo, rechazarlo o presentar una contraoferta. Si no se toma ninguna acción antes de la fecha y hora indicadas, la negociación se cancelará automáticamente.',
            notificationMsgSeller:
                'El comprador puede revisar el precio propuesto y decidir aceptarlo, rechazarlo o presentar una contraoferta. Si no se toma ninguna acción antes de la fecha y hora indicadas, la negociación se cancelará automáticamente.',
            notifyNewOffer:
                'Tiene nuevas ofertas pendientes de decisión. Revise los precios propuestos y acepte, rechace o contraargumente cada oferta según sea necesario.',
            respondToOffer: 'Responder a la(s) oferta(s)',
        },
        myOrders: {
            header: 'Mis pedidos',
            numberOfOrders_zero: 'Sin pedidos',
            numberOfOrders_one: '1 Pedido',
            numberOfOrders_other: '{{count}} Pedidos',
            noResultsDescription: 'Ningún resultado coincide con estos filtros.',
            noOrdersCallToAction: 'Limpiar filtros',
            bannerBuy: {
                header: 'Compre su primer producto',
                subHeader: 'Compre material y aproveche nuestra promesa SteelBuy:',
                description: [
                    'Acceso instantáneo a materiales para ahorrar tiempo.',
                    'La forma más rápida de comprar acero, donde la tecnología hace el trabajo.',
                    'Proceso de pedido totalmente gestionado.',
                ],
                buttonLabel: 'Buscar anuncios',
            },
            searchPlaceHolder: 'Su número de orden de compra',
            noOrdersCallToActionClearSearch: 'Limpiar búsqueda',
            noOrdersCallToActionClearBoth: 'Limpiar búsqueda y filtros',
            noResultsDescriptionForSearch: 'No hay resultados para "{{number}}"',
            noResultsDescriptionForBoth:
                'No se encontraron resultados para "{{number}}" o coincidentes con los filtros seleccionados.',
        },
        myOrdersFilter: {
            selectLabel: 'Filtrar por',
            selectPlaceholder: 'Elija una opción',
        },
        myOrderDetails: {
            marketingBannerHeader: '¿Tiene preguntas sobre su pedido?',
            marketingBannerText: 'No dude en contactarnos en:',
            purchaseOrderNumbersHeader: 'Números de órdenes de compra',
            purchaseOrderNumberHeader: 'Número de orden de compra',
            steelbuyPurchaseOrderNumberLabel: 'N.º de orden de compra SteelBuy',
            buyerPurchaseOrderNumberLabel: 'Su n.º de orden de compra',
            backLinkText: 'Mis pedidos',
            steelBuyReferenceNoLabel: 'N.º de referencia SteelBuy',
        },
        myOrderDetailsNotFound: {
            pageTitle: 'Pedido no encontrado',
            previousPageTitle: 'Mis pedidos',
            notFoundMessage: 'No se pudo encontrar este pedido.',
        },
        myOrderDetailsStatus: {
            cardHeader: 'Estado del pedido',
            delivered: 'Entregado',
            delivery: 'Entrega',
            freight_booked: 'Flete reservado',
            processing: 'Procesando pedido',
            processed: 'Pedido procesado',
            shipping: 'Envío',
            shippingConfirmed: 'Envío confirmado',
        },
        offerSuccess: {
            title: 'Su oferta',
            successText: '¡SteelBuy ha recibido su oferta!',
            referenceNumberText: 'Número de referencia SteelBuy:',
            responseHint: 'Pronto recibirá una respuesta del vendedor sobre su oferta.',
            manageOffers: 'Gestione sus ofertas en <link1>Mis ofertas</link1>.',
        },
        pickupAddressStep: {
            anonymityBannerHeader: '¡La anonimidad es importante para nosotros!',
            anonymityBannerText: 'Su dirección es necesaria para la recogida y solo es visible para SteelBuy.',
            incompleteInformationNotification: 'Por favor proporcione información completa para proceder al resumen.',
            filesUploadingNotification: 'Por favor espere a que finalice la carga de archivos.',
            additionalInformationLabel: 'Notas de dirección de recogida (opcional)',
            additionalInfoPlaceholder:
                'p. ej., instrucciones de estacionamiento, contacto del personal de almacén, etc.',
            deliveryTimeframeHeader: 'Plazo de entrega',
            deliveryTimeframeLabel: 'Su plazo de entrega del paquete actual.',
        },
        privacyPolicy: {
            headerTitle: 'Política de Privacidad',
            cookieLinks: {
                edge: 'https://enablecookies.info/#es-edge',
                safari: 'https://enablecookies.info/#es-safari',
                chrome: 'https://enablecookies.info/#es-chrome',
                firefox: 'https://enablecookies.info/#es-firefox',
                opera: 'https://enablecookies.info/#es-opera',
            },
        },
        purchaseContactEdit: {
            backLinkText: 'Cuenta de empresa',
            emailFieldLabel: 'Correo electrónico',
            headerTitle: 'Contacto de compras',
            nameFieldLabel: 'Nombre',
            notificationErrorMessage: 'Error al guardar, por favor intente más tarde',
            saveButtonLabel: 'Guardar cambios',
        },
        renewListingSuccess: {
            notificationMessage: '¡Su anuncio está activo!',
            notificationHelperText: 'ID de anuncio SteelBuy: {{steelbuyListingID}}',
            bannerHeader: '¿Tiene preguntas sobre su anuncio?',
            bannerText: 'No dude en contactarnos en:',
            myListingsButtonLabel: 'Mis anuncios',
        },
        rfqHeadingLabels: {
            grade: 'Grado',
            specification: 'Especificación',
            finish: 'Acabado',
            width: 'Ancho',
            thickness: 'Espesor',
            length: 'Longitud',
            weight: 'Peso',
            tolerance: 'Tolerancia',
            surface: 'Superficie',
            coating: 'Recubrimiento',
            coatingThicknessValue: 'Espesor de recubrimiento',
            gradeFamily: 'Familia de grado',
            coatingWeight: 'Peso de recubrimiento',
            surfaceTreatment: 'Tratamiento superficial',
            temper: 'Templado',
            compliance: 'Cumplimiento',
            surfaceFinish: 'Acabado superficial',
            thicknessOption: 'Opciones de espesor',
            thicknessType: 'Tipo de espesor',
            thicknessMax: 'Espesor',
            deliveryAddress: 'Dirección de entrega',
            widthOption: 'Opciones de ancho',
            quality: 'Calidad',
        },
        sellerListingDetails: {
            rejectionReason: {
                title: 'Motivo de rechazo',
                description: 'Contacte a soporte si tiene preguntas sobre el proceso de revisión.',
                buttonLabel: 'Contactar Soporte',
                emailSubject: 'Rechazo de anuncio {{sellerSku}}',
            },
            weightAndSellingPrice: {
                title: 'Peso y Precio',
                offerTitle: 'Peso y su precio de venta',
                weight: 'Peso y precio original',
                notification: 'Añadiremos una tarifa de envío y servicio a su precio.',
                offerNotification: 'Añadiremos una tarifa de envío y servicio al precio total del comprador.',
                newSellingPriceHeader: 'Su nuevo precio de venta por {{tradeUnit}}',
            },
            checkboxLabel:
                'Al marcar esta casilla, acepto en nombre de {{organisationName}} que he leído y acepto los siguientes términos y condiciones: <websitetncs>Términos y Condiciones del Sitio</websitetncs>, <sellertncs>Términos y Condiciones para Vendedores</sellertncs>.',
            createSameButtonLabel: 'Crear anuncio similar',
            renewButtonLabel: 'Publicar en el mercado',
            save: 'Guardar',
            listingHasUnsavedChanges: 'Este anuncio tiene cambios sin guardar.',
            updateError: 'Error al guardar cambios en el anuncio.',
            updateSuccess:
                'Sus actualizaciones se han guardado con éxito y se reflejarán en el mercado una vez que su anuncio actual expire y se renueve automáticamente.',
        },
        sellerListingDetailsNotFound: {
            pageTitle: 'Anuncio no encontrado',
            previousPageTitle: 'Mis anuncios',
            notFoundMessage: 'No se pudo encontrar este anuncio. Puede haberse convertido en borrador.',
        },
        termsAndConditions: {
            pageHeader: 'Términos y Condiciones',
        },
        navigation: {
            itemLabels: {
                account: 'Cuenta',
                alerts: 'Mis alertas',
                createListing: 'Crear anuncio',
                dashboard: 'Panel',
                manageOffers: 'Gestionar ofertas',
                myListings: 'Mis anuncios',
                myOffers: 'Mis ofertas',
                myOrders: 'Mis pedidos',
                searchListing: 'Buscar anuncios',
                requestMaterial: 'Solicitar material',
                activeRequests: 'Solicitudes activas',
                createRfq: 'Crear RFQ',
                myRfqs: 'Mis RFQs',
            },
            menuButtonLabel: 'Menú',
        },
        navigationItemUser: {
            logoutButtonLabel: 'Cerrar sesión',
        },
        navigationFooter: {
            loginButtonLabel: 'Iniciar sesión',
        },
        warehouseAddressSelection: {
            chooseAddressButtonLabel: 'Elegir dirección',
            addNewAddress: 'Agregar nueva dirección',
        },
        organisation: {
            addressAddedNotificationText:
                'Gracias por añadir una nueva dirección de almacén. Nuestro equipo validará la nueva dirección antes de que aparezca en su lista. Estamos en ello.',
            addressDeletedNotificationText: 'La dirección ha sido eliminada.',
            addressUpdatedNotificationText: 'La dirección ha sido actualizada.',
            createNewButtonLabel: 'Agregar nueva dirección',
            creditCardHeader: 'Crédito',
            creditLineBalanceLabel: 'Saldo de crédito restante',
            creditLineTotalLabel: 'Saldo total de crédito',
            invoiceAddressCardHeader: 'Dirección de facturación',
            organisationCardHeader: 'Empresa',
            organisationCardNameLabel: 'Nombre',
            organisationSavedNotificationText: 'Los cambios se han guardado con éxito.',
            paymentSectionHeading: 'Pago',
            paymentTermsHeader: 'Condiciones de pago de compras',
            primaryAddressTag: 'Principal',
            purchaseContactCardHeader: 'Contacto de compras',
            purchaseContactNameLabel: 'Nombre',
            purchaseContactEmailLabel: 'Correo electrónico',
            warehouseAddressHeader: 'Dirección de almacén {{number}}',
            warehouseAddressesSectionHeading: 'Direcciones de almacén',
            paymentTerms: {
                [PaymentTerms.NET_30_DAYS]: '30 días desde la fecha de la factura',
                [PaymentTerms.NET_60_DAYS]: '60 días desde la fecha de la factura',
                [PaymentTerms.HALF_PERCENT_TEN_NET_30_DAYS]:
                    '0,5% de descuento si se paga dentro de los 10 días; de lo contrario 30 días a partir de la fecha de la factura',
                [PaymentTerms.ONE_PERCENT_TEN_NET_30_DAYS]:
                    '1% de descuento si paga dentro de los 10 días; de lo contrario 30 días a partir de la fecha de la factura',
            },
        },
        pageTitle: 'Mercado SteelBuy',
        urgentRequests: {
            pageHeader: 'Solicitud de Material Inmediato',
            settingsButtonLabel: 'Configuración',
            newResultsSeparatorHeader_zero: 'Sin nuevos resultados (últimas 24 h)',
            newResultsSeparatorHeader_one: '1 nuevo resultado (últimas 24 h)',
            newResultsSeparatorHeader_other: '{{count}} nuevos resultados (últimas 24 h)',
            emptyStateDescription: 'Actualmente no hay solicitudes de material inmediato.',
            createListing: 'Crear anuncio',
            qna: {
                header: 'Preguntas y Respuestas',
                items: {
                    q1: {
                        label: '¿Cómo funcionan las solicitudes de material inmediato?',
                        content:
                            'Si es vendedor, puede crear un anuncio basado en la solicitud inmediata del comprador. Una vez activo, notificaremos al comprador los nuevos matches por correo. Si es comprador, puede activar la solicitud inmediata tras buscar material y le avisaremos por correo cuando aparezca material coincidente. En “Mis alertas” puede gestionar sus búsquedas notificadas.',
                    },
                    q2: {
                        label: '¿Cómo seré notificado?',
                        content:
                            'Si hay una solicitud inmediata en SteelBuy, le enviaremos un correo a la dirección de su cuenta.',
                    },
                    q3: {
                        label: '¿Con qué frecuencia seré notificado?',
                        content:
                            'Actualmente le notificamos por correo cada vez que hay un nuevo resultado para sus criterios. También puede especificar la frecuencia preferida de notificaciones.',
                    },
                    q4: {
                        label: '¿Cómo desactivo las solicitudes inmediatas?',
                        content:
                            'Puede silenciar o eliminar su alerta de solicitud inmediata en la configuración de solicitudes inmediatas.',
                    },
                },
            },
            new: 'nueva',
        },
        urgentRequestsSettings: {
            pageHeader: 'Configuración de Solicitud de Material Inmediato',
            headerBackLinkLabel: 'Solicitud de Material Inmediato',
            changesSavedNotificationMessage: '¡Sus cambios han sido guardados!',
            mailNotificationHeader: 'Notificaciones por correo',
            mailNotificationLabel:
                'Recibirá un correo a {{email}} cuando se cree una solicitud inmediata (según su frecuencia).',
            receiveNotifications: 'Recibir notificaciones',
            saveButtonLabel: 'Guardar cambios',
            notificationFrequencyHeader: 'Frecuencia de notificación',
            notificationFrequencyLabel: 'Recibirá notificaciones según su selección de frecuencia',
        },
        urgentRequestForm: {
            pageHeader: 'Su solicitud de material inmediato',
            warningMessage:
                'Por favor seleccione e ingrese los criterios detallados para crear una solicitud inmediata de material.',
            infoMessage: 'Por favor complete los campos requeridos para crear una solicitud inmediata de material.',
            submitButtonLabel: 'Enviar solicitud',
            createdAlertMessageNoMatch: 'Ha creado una solicitud inmediata de material.',
            createdAlertMessageWithMatch: 'Ha creado una solicitud inmediata de material y encontrado un resultado.',
            failedToCreate: 'Actualmente no podemos crear su alerta, por favor intente más tarde.',
        },
        userForm: {
            nameFieldLabel: 'Nombre',
            permissionsFieldLabel: 'Permisos',
            emailFieldLabel: 'Correo electrónico',
            activateToggleLabel: 'Usuario activo',
            deactivateUserModal: {
                modalTitle: '¿Está seguro de que desea desactivar este usuario?',
                confirmButtonLabel: 'Sí, desactivarlo',
            },
            activateUserModal: {
                modalTitle: '¿Está seguro de que desea reactivar este usuario?',
                confirmButtonLabel: 'Sí, reactivarlo',
            },
            errors: {
                invalidDomain: 'El correo debe ser del mismo dominio que la empresa',
                other: 'Error',
            },
        },
        userManagement: {
            emailHeader: 'Correo electrónico',
            permissionsHeader: 'Permisos',
            createUserSuccess: 'El usuario ha sido creado.',
            updateUserSuccess: 'El usuario ha sido actualizado.',
        },
        time: {
            day_one: '1 día',
            day_other: '{{count}} días',
        },
    },
    error: {
        noUserError: 'Ningún usuario cargado',
    },
};
